import React from "react";
import { Skeleton } from "antd";

const NovaAiInitialLoader = () => {
  return (
    <div className="nova-skeleton-wrapper">
      {/* Assistant left */}
      <div className="skeleton-initial-loader left">
        <div className="nova-skeleton-line bot" />
        <Skeleton active className="nova-skeleton-initial-lines" />
      </div>

      {/* User right */}
      <div className="skeleton-initial-loader right">
        <Skeleton active className="nova-skeleton-initial-lines" />
        <div className="nova-skeleton-line bot" />
      </div>

      {/* Assistant left */}
      <div className="skeleton-initial-loader left">
        <div className="nova-skeleton-line bot" />
        <Skeleton active className="nova-skeleton-initial-lines" />
      </div>
    </div>
  );
};

export default NovaAiInitialLoader;
